import { Col, Label, ReactSelectBox } from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";
import { useMemo } from "react";

const ManagedEquipement = (props?: any) => {
  const {
    handleSelectionChange,
    managedEquipmentValues,
    manufacturerDropDownList,
    categoryDropdownList,
    SizeDropDownList,
    TypeDropDownList,
    StyleDropDownList,
    lengthDropDownList,
    fuelTankDropDownList,
    chargingStationDropdownList,
    managedEquipRef,
    type
  } = props

  const manufacturerValue: any = useMemo(() => {
    return manufacturerDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.manufacturerId)
  }, [managedEquipmentValues?.manufacturerId, manufacturerDropDownList])

  const categoryValue: any = useMemo(() => {
    return categoryDropdownList?.find((i: any) => i?.key == managedEquipmentValues?.categoryId)
  }, [managedEquipmentValues?.categoryId, categoryDropdownList])

  const sizeValue: any = useMemo(() => {
    return SizeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.sizeId)
  }, [managedEquipmentValues?.sizeId, SizeDropDownList])

  const typeValue: any = useMemo(() => {
    return TypeDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.typeId)
  }, [managedEquipmentValues?.typeId, TypeDropDownList])

  const styleValue: any = useMemo(() => {
    return StyleDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.styleId)
  }, [managedEquipmentValues?.styleId, StyleDropDownList])

  const lengthValue: any = useMemo(() => {
    return lengthDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.lengthId)
  }, [managedEquipmentValues?.lengthId, lengthDropDownList])

  const fuelTankValue: any = useMemo(() => {
    return fuelTankDropDownList?.find((i: any) => i?.key == managedEquipmentValues?.fuelTankId)
  }, [managedEquipmentValues?.fuelTankId, fuelTankDropDownList])

  const chargingStationValue: any = useMemo(() => {
    return chargingStationDropdownList?.find((i: any) => i?.key == managedEquipmentValues?.chargingStationId)
  }, [managedEquipmentValues?.chargingStationId, chargingStationDropdownList])


  return (<>
    {type === CONSTANTS.CONSTRUCTION_EQUIPMENT ?
      <>      
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="ManagedEquipement_Default_Label">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleSelectionChange(e, item, 'categoryId', 2)}
          value={categoryValue}
          selectRef={(element: any) => managedEquipRef.current[1] = element}
         data-attribute="ManagedEquipement_Default_SearchSelectBox" />
      </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_2">Manufacturer</Label>
          <ReactSelectBox
            options={manufacturerDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'manufacturerId', 2)}
            value={manufacturerValue}
            selectRef={(element: any) => managedEquipRef.current[2] = element}
           data-attribute="ManagedEquipement_Default_SearchSelectBox_2" />
        </Col>
        </>
      : null}
      {type !== CONSTANTS.CONSTRUCTION_EQUIPMENT ? 
    <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="ManagedEquipement_Default_Label_3">Manufacturer</Label>
      <ReactSelectBox
        options={manufacturerDropDownList}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'manufacturerId', 2)}
        value={manufacturerValue}
        selectRef={(element: any) => managedEquipRef.current[1] = element}
       data-attribute="ManagedEquipement_Default_SearchSelectBox_3" />
    </Col> : null}

    {type === CONSTANTS.TRAILER ?
      <>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_4">Style</Label>
          <ReactSelectBox
            options={StyleDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'styleId', 3)}
            value={styleValue}
            selectRef={(element: any) => managedEquipRef.current[2] = element}

           data-attribute="ManagedEquipement_Default_SearchSelectBox_4" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_5">Length</Label>
          <ReactSelectBox
            options={lengthDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'lengthId', 4)}
            value={lengthValue}
            selectRef={(element: any) => managedEquipRef.current[3] = element}
           data-attribute="ManagedEquipement_Default_SearchSelectBox_5" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_6">Fuel-Tank</Label>
          <ReactSelectBox
            options={fuelTankDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'fuelTankId', 5)}
            value={fuelTankValue}
            selectRef={(element: any) => managedEquipRef.current[4] = element}

           data-attribute="ManagedEquipement_Default_SearchSelectBox_6" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_7">Charging Station</Label>
          <ReactSelectBox
            options={chargingStationDropdownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'chargingStationId')}
            value={chargingStationValue}
            selectRef={(element: any) => managedEquipRef.current[5] = element}
           data-attribute="ManagedEquipement_Default_SearchSelectBox_7" />
        </Col>

      </>
      : null}
    {type === CONSTANTS.SNOW || type === CONSTANTS.STANDARIZED_EQUIPMENT ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="ManagedEquipement_Default_Label_8">Category</Label>
        <ReactSelectBox
          options={categoryDropdownList}
          onChange={(item: any, e: any) => handleSelectionChange(e, item, 'categoryId', 3)}
          value={categoryValue}
          selectRef={(element: any) => managedEquipRef.current[2] = element}
         data-attribute="ManagedEquipement_Default_SearchSelectBox_8" />
      </Col> : null}
    {type === CONSTANTS.SNOW ?
      <>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_9">Size</Label>
          <ReactSelectBox
            options={SizeDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'sizeId', 4)}
            value={sizeValue}
            selectRef={(element: any) => managedEquipRef.current[3] = element}
            isSearchable={true}
           data-attribute="ManagedEquipement_Default_SearchSelectBox_9" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="ManagedEquipement_Default_Label_10">Type</Label>
          <ReactSelectBox
            options={TypeDropDownList}
            onChange={(item: any, e: any) => handleSelectionChange(e, item, 'typeId', 5)}
            value={typeValue}
            selectRef={(element: any) => managedEquipRef.current[4] = element}
           data-attribute="ManagedEquipement_Default_SearchSelectBox_10" />
        </Col>
      </>
      : null}

    {/*
    
    /// Waiting for tony's reply on dropdown values

     <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
      <Label data-attribute="ManagedEquipement_Default_Label_11">Parent Vehicle</Label>
      <ReactSelectBox
        options={parentVehicleOption}
        onChange={(item: any, e: any) => handleSelectionChange(e, item, 'parentVehicleId')}
        value={parentVehicleOption?.find((i: any) => i?.key === managedEquipmentValues?.parentVehicleId)}
        selectRef={(element: any) => managedSnowRef.current[5] = element}
       data-attribute="ManagedEquipement_Default_SearchSelectBox_11" />
    </Col> */}
  </>)
}

export default ManagedEquipement;
